import React, { useEffect, useState } from 'react';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { useT } from 'client/i18n/hooks/useT';

export function SubmitPublishButton(props: {
  isSubmitting: boolean;
  isPublished?: boolean;
  pristine: boolean;
}) {
  const { isPublished, pristine, isSubmitting } = props;
  const [isActive, setIsActive] = useState(false);
  const t = useT();

  function getText() {
    if (isActive && isSubmitting) {
      return isPublished
        ? t('Button.Saving', 'Saving...', 'Saving button text')
        : t('Button.Publishing', 'Publishing...', 'Publishing button text');
    }
    return isPublished
      ? t('Button.SavePoll', 'Save poll', 'Save poll button text')
      : t('Button.PublishPoll', 'Publish poll', 'Publish poll button text');
  }

  useEffect(() => {
    if (!isSubmitting) {
      setIsActive(false);
    }
  }, [isSubmitting]);

  return (
    <ButtonPrimary
      type="submit"
      disabled={isSubmitting || (pristine && isPublished)}
      onClick={() => {
        setIsActive(true);
      }}
    >
      {getText()}
    </ButtonPrimary>
  );
}
